import { Locales } from '../../models/locale/locales';

export const getTranslation = (baseLocale: Locales = 'fr-FR'): Locales => {
  const params = new URLSearchParams(window.location.search);
  const locale = params.get('lang') as Locales;
  return locale || baseLocale;
};
